import React, { useState, useEffect } from "react";
import { sendSignInLinkToEmail, signInWithEmailLink, isSignInWithEmailLink } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase"; // Import the configured auth from firebase.js
import "../styles/Login.css"; // Import your styling file

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    // Check if the URL contains a sign-in link
    if (isSignInWithEmailLink(auth, window.location.href)) {
      const storedEmail = localStorage.getItem("emailForSignIn");
      const userEmail = storedEmail || window.prompt("Please confirm your email:");

      if (userEmail) {
        signInWithEmailLink(auth, userEmail, window.location.href)
          .then(() => {
            localStorage.removeItem("emailForSignIn"); // Clean up stored email
            navigate("/dashboard"); // Redirect after successful login
          })
          .catch((error) => {
            console.error("Error during sign-in:", error.message);
            setError("Failed to sign in. Please try again.");
          });
      }
    }
  }, [navigate]);

  // Handle sending the passwordless sign-in link
  const handleSendLink = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!email) {
      setError("Please enter your email.");
      return;
    }

    const actionCodeSettings = {
      url: `${window.location.origin}/`, // Redirect to the login page
      handleCodeInApp: true,
    };

    try {
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);
      localStorage.setItem("emailForSignIn", email); // Save the email locally
      setMessage("Sign-in link sent! Please check your email.");
    } catch (error) {
      console.error("Error sending sign-in link:", error.message);
      setError("Failed to send sign-in link. Please try again.");
    }
  };

  return (
    <div className="login-container">
      <h1>HonestAI Admin Login</h1>
      <form onSubmit={handleSendLink} className="login-form">
        <div className="input-group">
          <label>Email</label>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        {message && <p className="success-message">{message}</p>}
        <button type="submit" className="login-button">
          Send Sign-in Link
        </button>
      </form>
    </div>
  );
};

export default Login;
